export default __webpack_public_path__ + "static/media/FlagEngland.da253f38.jpg";